module.exports = __webpack_public_path__ + "img/goods5_4.135d44ea.jpg";